import type { IScheduledCustomReport } from '@/Interfaces/ReportBuilder/ScheduledCustomReport.interface';
import { dateToShortFormat } from '@/helpers/valueFormatter/dateFormatter.helpers';
import type {
  CustomReportCancelScheduledFunction,
  CustomReportEditScheduledFunction,
} from '@/types/ReportBuilder/GridFunction.types';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import ActionChip from './ActionChip';
import EmailsCell from './EmailsCell';

export const getColumns = (
  onCancelScheduledReport: CustomReportCancelScheduledFunction,
  onEditScheduledReport: CustomReportEditScheduledFunction,
): GridColDef[] => [
  {
    field: 'name',
    flex: 2,
    headerName: 'Report Name',
  },
  {
    field: 'interval',
    flex: 1,
    headerName: 'Interval',
  },
  {
    field: 'customReports',
    flex: 1,
    headerName: 'Last Date Sent',
    sortable: false,
    valueFormatter: (value: IScheduledCustomReport['customReports']) => dateToShortFormat(value?.[0]?.updatedAt),
  },
  {
    field: 'recipientEmails',
    flex: 3.5,
    headerName: 'Recipient Emails',
    sortable: false,
    display: 'flex',
    renderCell: EmailsCell,
  },
  {
    field: 'id',
    flex: 1,
    headerName: 'Action',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    display: 'flex',
    renderCell: (params: GridRenderCellParams) => (
      <ActionChip
        {...params}
        onCancelScheduledReport={onCancelScheduledReport}
        onEditScheduledReport={onEditScheduledReport}
      />
    ),
  },
];
